<template>
  <v-form>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-autocomplete
              v-model="currFilters.service"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="service"
              :items="services"
              :loading="loading"
              item-text="title"
              item-value="id"
              :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              @change="service = ''"
            />
          </td>
          <td>
            <building-complexes-filter
              v-model="currFilters.building_complex"
              :label="$t('DATA_TABLE.FILTER')"
              item-text="name"
              item-value="id"
              multiple
              chips
              small-chips
              deletable-chips
            />
          </td>
          <td>
            <business-customers-filter
              v-model="currFilters.business_customer"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              multiple
              chips
              small-chips
              deletable-chips
            />
          </td>
          <td>
            <management-companies-filter
              v-model="currFilters.management_company"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              multiple
              chips
              small-chips
              deletable-chips
            />
          </td>
          <td>
            <v-select
              v-model="currFilters.status"
              :items="statuses"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
            />
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn
              color="primary"
              depressed
              type="submit"
              @click.prevent="setFilters"
            >
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { BaseService } from '@/services/base.service';
import BuildingComplexesFilter from '@/modules/_global/_components/list_filters/BuildingComplex/BuildingComplexesFilter.vue';
import BusinessCustomersFilter from '@/modules/_global/_components/list_filters/BusinessCustomer/BusinessCustomersSelectFilter.vue';
import ManagementCompaniesFilter from '@/modules/_global/_components/list_filters/ManagementCompany/ManagementCompaniesSelectFilter.vue';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'BuildingComplexesContractsListFilter',
  components: {
    ManagementCompaniesFilter,
    BusinessCustomersFilter,
    BuildingComplexesFilter
  },
  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listFilters],

  props: {},

  data() {
    return {
      delay: 0,

      service: null,
      services: [],

      statuses: []
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('contracts', ['filters']),
    headers() {
      return [
        {
          text: this.$t('ABO_SERVICES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEMS'),
          sortable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER'),
          sortable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY'),
          sortable: false
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    }
  },

  watch: {},

  mounted() {
    BaseService.getStatuses().then(({ data }) => {
      this.statuses = data.data;
    });
    this.getAboServices();
    this.setFilters();
    this.setDelay(500);
  },

  methods: {
    ...mapActions('contracts', ['getServicesFilterList']),

    getAboServices() {
      this.getServicesFilterList().then(({ data }) => {
        this.services = data.data;
      });
    },

    setDelay(v) {
      this.delay = v;
    },

    reset() {
      this.currFilters = {};

      this.setFilters();
    }
  }
};
</script>
